import { Sim } from '../interfaces/sims';
import { CacheService } from '../ssr-services/cache/cache.service';

export function uniqueCountriesAndRegionsIsoCode(
  sim: Sim,
  cacheService: CacheService
): Set<string> {
  const countManager = new Set<string>();

  const simImsiId = sim.imsiId;

  const imsiIndex = cacheService.imsiIndexes();

  if (!imsiIndex || Object.keys(imsiIndex).length === 0) {
    return countManager;
  }

  // Convert number to string since ImsiIndex uses string keys (e.g., "7")
  const imsiIdKey = String(simImsiId);

  const imsiDetails = imsiIndex[imsiIdKey];

  const supportedCountries = imsiDetails?.supportedCountries ?? [];
  const supportedRegions = imsiDetails?.supportedRegions ?? [];

  // supportedCountries is an array of ISO codes (strings), not Country objects
  for (const countryCode of supportedCountries) {
    countManager.add(countryCode);
  }

  // supportedRegions is an array of region names (strings)
  for (const regionName of supportedRegions) {
    countManager.add(regionName);
  }

  return countManager;
}
